import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as SVG } from './map.svg';

const MapIcon = React.memo(({ className }) => (
  <div
    className={className}
    style={{
      background: 'transparent',
      verticalAlign: 'middle',
    }}>
    <SVG />
  </div>
));

MapIcon.propTypes = {
  className: PropTypes.string.isRequired,
};

export default MapIcon;
